import { render, staticRenderFns } from "./institutionForm.vue?vue&type=template&id=5ab8c859&scoped=true"
import script from "./institutionForm.vue?vue&type=script&lang=js"
export * from "./institutionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab8c859",
  null
  
)

export default component.exports